import { STATUS_STEPS, stepIndex } from "@/lib/statusLabels";
import { Check } from "lucide-react";

export default function StatusTimeline({ current }) {
  const activeIdx = stepIndex(current);
  return (
    <ol className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="status-timeline">
      {STATUS_STEPS.map((step, idx) => {
        const done = idx < activeIdx;
        const active = idx === activeIdx;
        return (
          <li key={step.key} className="relative">
            <div
              className={`rounded-lg border p-3 text-left transition-colors ${
                done
                  ? "border-[#1E3A8A] bg-[#1E3A8A]/5"
                  : active
                  ? "border-[#1E3A8A] bg-white shadow-sm ring-2 ring-[#1E3A8A]/30"
                  : "border-slate-200 bg-white"
              }`}
              data-testid={`step-${step.key}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <span
                  className={`inline-flex w-6 h-6 rounded-full items-center justify-center text-xs font-bold ${
                    done
                      ? "bg-[#1E3A8A] text-white"
                      : active
                      ? "bg-[#1E3A8A] text-white"
                      : "bg-slate-200 text-slate-600"
                  }`}
                >
                  {done ? <Check className="w-3.5 h-3.5" /> : idx + 1}
                </span>
                <span className="text-[10px] uppercase tracking-widest text-slate-500">
                  Step {idx + 1}
                </span>
              </div>
              <div
                className={`text-sm font-semibold ${
                  done || active ? "text-[#0A192F]" : "text-slate-500"
                }`}
              >
                {step.label}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
